var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SoliForm", {
        ref: "form",
        attrs: {
          textSubtitle: `To: ${_vm.emails.join(", ")}`,
          retainFocus: false,
          persistent: "",
          loadingProp: _vm.loading,
          large: "",
          title: "Compose Email",
          text: "Send it!",
          icon: "email",
          limitSubtitle: "",
        },
        on: {
          submit: function ($event) {
            return _vm.submit()
          },
          reset: function ($event) {
            return _vm.reset()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-2 mb-3" },
                  [
                    _vm.can("Email as studio") && _vm.sendAsStudio
                      ? _c("v-select", {
                          attrs: {
                            label: "From",
                            items: [
                              _vm.user.email,
                              _vm.user.selected_location.email,
                            ],
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            errors: _vm.errors.emailFrom,
                            rules: _vm.rules.select,
                          },
                          model: {
                            value: _vm.emailFrom,
                            callback: function ($$v) {
                              _vm.emailFrom = $$v
                            },
                            expression: "emailFrom",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.can("Email as studio")
                      ? _c("SoliStudents", {
                          attrs: {
                            label: _vm.form.bcc ? "BCC:" : "CC:",
                            icon: false,
                            dense: "",
                            autocomplete: "",
                            multiple: "",
                            hasEmail: "",
                            chips: "",
                            deletableChips: "",
                            smallChips: "",
                            closeOnClick: "",
                            onDemand: "",
                            hideDetails: "auto",
                            "single-line": "",
                            includeTeachers: "",
                          },
                          model: {
                            value: _vm.form.cc,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "cc", $$v)
                            },
                            expression: "form.cc",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.subject
                      ? _c("SoliText", {
                          attrs: {
                            label: "Subject",
                            rules: _vm.rules.input,
                            errors: _vm.errors?.subject,
                            validateOnBlur: "",
                            "hide-details": "auto",
                          },
                          model: {
                            value: _vm.form.subject,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "subject", $$v)
                            },
                            expression: "form.subject",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.greeting && !_vm.form.bcc
                  ? _c("div", { staticClass: "px-1 mb-3" }, [
                      _c("small", { staticClass: "soli-grey" }, [
                        _vm._v("Hey [first_name]"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tinyMCE
                  ? _c("TinyEditor", {
                      attrs: { errors: _vm.errors?.message },
                      model: {
                        value: _vm.form.message,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "message", $$v)
                        },
                        expression: "form.message",
                      },
                    })
                  : _c("v-textarea", {
                      attrs: {
                        "error-messages": _vm.errors?.message,
                        rules: _vm.rules.input,
                        outlined: "",
                        placeholder: "What's on your mind?",
                        height: 300,
                      },
                      model: {
                        value: _vm.form.message,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "message", $$v)
                        },
                        expression: "form.message",
                      },
                    }),
                _vm._v(" "),
                _vm.signature
                  ? _c("div", { staticClass: "pl-1 pb-3" }, [
                      _c("small", { staticClass: "soli-grey" }, [
                        _vm._v("Thanks! "),
                        _c("br"),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.user.name) +
                            "\n                "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }